import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { IInquiry } from '../../interfaces/inquiry.interface';
import { InquiryListItemDate } from '../molecules/InquiryListItemDate';
import { InquiryListItemFacility } from '../molecules/InquiryListItemFacility';
import { InquiryListItemInquiryCategory } from '../molecules/InquiryListItemInquiryCategory';
import { InquiryListItemMessage } from '../molecules/InquiryListItemMessage';
import { AtomsLink } from '../atoms';
import { useRootStore } from '../../App';

const StyledDivTableRow = styled.div`
  display: table-row;
  background-color: #fff !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  font-style: normal !important;
  font-size: 13px !important;
  cursor: pointer !important;
  font-weight: ${(props: { isRead: boolean }) =>
    props.isRead ? 'normal !important' : 'bold !important'};
`;

const StyledTableCell = styled.div`
  display: table-cell;
  color: #333333;
  word-wrap: break-word;
  width: 245px;
  border-top: solid 1px #ebebeb !important;
  padding: 12px 0 12px 16px !important;
  font-size: 13px !important;
  text-align: left;
  position: relative;
`;

const StyledAtomsLink = styled(AtomsLink)`
  position: relative;
  display: block;
  text-align: left;
  padding: 12px 16px 12px 40px;
  color: #333;
  text-decoration: none;
  background: #fff;
  border-top: solid 1px #e2e2e2;
  width: calc(100vw - 56px);
  &::before {
    position: absolute;
    content: '';
    display: ${(props: { isRead: boolean }) =>
      props.isRead ? 'none' : 'block'};
    width: 8px;
    height: 8px;
    background: #bf0000;
    top: 0;
    bottom: 0;
    left: 16px;
    margin: auto;
    border-radius: 50%;
  }
`;

const StyledDiv = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
`;

interface Props {
  inquiry: IInquiry;
  className: string;
}

export const InquiryListItem = observer((props: Props) => {
  const root = useRootStore();
  const { setActiveInquiryId, recipients } = root.inquiryStore;
  const { isWide } = root.layoutStore;
  const { getInquiryCategory } = root.faqStore;
  const { inquiry, className } = props;

  // multiple recipients are not supported
  const firstRecipient = recipients.get(inquiry.recipients[0].userId);

  return isWide ? (
    <StyledDivTableRow
      className={`${className} inquiry-row`}
      onClick={() => {
        setActiveInquiryId(inquiry.inquiryId);
      }}
      isRead={inquiry.lastReadStatus}
    >
      <InquiryListItemFacility
        image={
          firstRecipient?.userIcon + `?fit=inside%7C${isWide ? 100 : 50}:*`
        }
        value={firstRecipient?.userName}
        isWide={isWide}
      />
      <StyledTableCell>
        <div>
          <InquiryListItemInquiryCategory
            value={getInquiryCategory(inquiry.inquiryCategory)}
            isWide={isWide}
          />
          <InquiryListItemMessage value={inquiry.lastMessage} isWide={isWide} />
        </div>
      </StyledTableCell>
      <InquiryListItemDate
        date={inquiry.lastMessageTimestamp}
        isWide={isWide}
      />
    </StyledDivTableRow>
  ) : (
    <li
      className={`${className} inquiry-row`}
      onClick={() => {
        setActiveInquiryId(inquiry.inquiryId);
      }}
    >
      <StyledAtomsLink
        to={`/inquiry/${inquiry.inquiryId}`}
        isRead={inquiry.lastReadStatus}
      >
        {/* force css update with body color, due to Travel ssi header/footer */}
        <span style={{ color: '#333' }}>
          <StyledDiv>
            <InquiryListItemFacility
              value={firstRecipient?.userName}
              isWide={isWide}
            />
            <InquiryListItemDate
              date={inquiry.lastMessageTimestamp}
              isWide={isWide}
            />
          </StyledDiv>
          <InquiryListItemInquiryCategory
            value={getInquiryCategory(inquiry.inquiryCategory)}
            isWide={isWide}
          />
          <InquiryListItemMessage value={inquiry.lastMessage} isWide={isWide} />
        </span>
      </StyledAtomsLink>
    </li>
  );
});
